export default function usePosthog() {
  const { $posthog } = useNuxtApp();
  const configPublic = useRuntimeConfig().public;

  function isPosthogEnabled(): boolean {
    return configPublic.posthogEnabled;
  }

  // TODO: replace usages of posthogLogError with logError() function
  function posthogLogError(error: {}) {
    if (
      configPublic.environment.toLowerCase() == Environment.DEVELOPMENT ||
      configPublic.environment.toLowerCase() == Environment.STAGING
    ) {
      console.error(error);
    }

    if (isPosthogEnabled()) {
      $posthog()?.capture(PosthogEvents.ERROR, error);
      $posthog()?.captureException(error);
    }
  }

  function logError(error: unknown, action: string, message?: string) {
    if (error) {
      posthogLogError({
        error,
        message: message,
        context: {
          userId: useUserStore().user?.id,
          action: action,
        },
      });
    }
  }

  function identifyIfNecessary() {
    const userStore = useUserStore();
    if (
      isPosthogEnabled() &&
      !$posthog()?._isIdentified() &&
      userStore.isUserLoggedIn
    ) {
      $posthog()?.identify(userStore.user?.id, {
        email: userStore.user?.email,
        role: userStore.user?.role,
        environment: configPublic.environment,
      });
    }
  }

  return {
    isPosthogEnabled,
    posthogLogError,
    logError,
    identifyIfNecessary,
  };
}

export enum PosthogEvents {
  LOG_IN = "Login",
  LOG_OUT = "Logout",
  ERROR = "Error",
}

export class CustomError extends Error {
  thrownError?: any;
  //   override message: string;
  type?: CustomErrorType;
  file?: string;

  constructor({
    thrownError,
    message,
    type,
    file,
  }: {
    thrownError?: any;
    message?: string;
    type?: CustomErrorType;
    file?: string;
  }) {
    super(message);

    this.thrownError = thrownError;
    this.type = type;
    this.file = file;
  }
}

export enum CustomErrorType {
  frontend = "frontend",
  backend = "backend",
}
